export default "__VITE_PUBLIC_ASSET__44174ad1__"